import {
  Button,
  Container,
  Grid,
  makeStyles,
  Paper,
  TextField,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';
import axios from 'axios';
import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';

const useStyle = makeStyles(({spacing}) => ({
  root: {
    marginTop: spacing(2),
    marginBottom: spacing(4),
    padding: '32px 16px',
  },
}));

export const TeacherUpdateClassroomForm = ({classroom = {}}) => {
  const classes = useStyle();
  const {tableData, ...classroomData} = classroom;
  const [formData, setFormData] = useState({
    ...classroomData,
    name: classroom.name ? classroom.name : 'Edit name...',
  });

  let history = useHistory();

  const updateFormData = (e) => {
    let updatedValue = e.target.value;
    if (e.target.name === 'isArchived') {
      updatedValue = e.target.checked;
    }
    setFormData({...formData, [e.target.name]: updatedValue});
  };

  const updateClassroom = async (event) => {
    event.preventDefault();
    try {
      await axios.post(`/api/classroom/${classroom._id}`, formData);
      history.go(0).push('/teacher/classrooms');
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Container
      component={Paper}
      elevation={0}
      maxWidth="sm"
      className={classes.root}
    >
      <form onSubmit={updateClassroom}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              label="Name"
              id="name"
              name="name"
              value={formData.name}
              onChange={updateFormData}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              label="Archive"
              control={
                <Checkbox
                  id="isArchived"
                  name="isArchived"
                  color="primary"
                  checked={formData.isArchived}
                  onChange={updateFormData}
                />
              }
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              value="formData"
            >
              Update Classroom
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};
